import * as types from "./types";
import _ from "lodash";
export default (state = null, action) => {
  switch (action.type) {
    case types.FETCH_MASTER_DDLS:
      // return { ...state, ..._.mapKeys(action.payload, "Id") };
      return action.payload;
    // return { ...state, [action.payload]: action.payload };
    default:
      return state;
  }
};
export const EmployeesDDL = (state = {}, action) => {
  switch (action.type) {
    case types.EMPLOYEES_DDLS:
      return action.payload;
    default:
      return state;
  }
};
export const RequestStatus = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_REQUEST_STATUS:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const PropertyTypes = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_PROPERTY_TYPES:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const UnitTypes = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_UNIT_TYPES:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const Countries = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_COUNTRIES:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const PaymentTypes = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_PAYMENT_TYPES:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const PropertiesDDL = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_PROPERTIES_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const MasterBankDDL = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_MASTER_BANK_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
function paymentMonths() {
  const months = [];
  for (let index = 1; index <= 12; index++) {
    months.push({
      label: `${index} Month`,
      value: index,
    });
  }
  return months;
}
export const DepartmentDDL = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_DEPARTMENT_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const PaymentMonths = (state = [], action) => {
  state = paymentMonths();
  return state;
};
export const MasterAssetDDL = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_MASTER_ASSET_DDL:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const PayrollColumnsList = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_PAYROLL_COLUMN_LIST:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const MasterEmirateDDL = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_EMIRATES:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
export const Projects = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_PROJECTS:
      return { ..._.mapKeys(action.payload, "value") };
    default:
      return state;
  }
};
